import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import { useAuth } from '@/features/auth/contexts/auth.context';
import { useInterviewContext } from '@/features/common/contexts/interview.context';
import OnboardingScreen from '@/features/onboarding/pages/OnboardingScreen';
import { useBooth } from '@/features/settings/hooks/useBooth';

import { useRegisterContext } from '../../contexts/register-context.ref';

export default function OnboardingPage() {
  const navigate = useNavigate();
  const { isLoading: isSessionPending, isAuthenticated } = useAuth();
  const { startInterview } = useRegisterContext();
  const { onReset } = useInterviewContext();
  const { booth, isBooth, isBoothDefaultLocaleEnabled } = useBooth();

  const isPreselected = isBoothDefaultLocaleEnabled && !!booth?.interfacePreselected;
  const shouldReturnHome = !isBooth || isPreselected;

  const handleStart = useCallback(() => {
    if (isAuthenticated && !isSessionPending) {
      void startInterview();
    } else {
      navigate('/register/cgu', { replace: true });
    }
  }, [isAuthenticated, isSessionPending, startInterview, navigate]);

  const handleBack = useCallback(() => {
    navigate(shouldReturnHome ? '/' : '/language', { replace: true });
  }, [navigate, shouldReturnHome]);

  return <OnboardingScreen onStart={handleStart} onCancel={onReset} onBack={handleBack} />;
}
